/**
 * Main TypeScript Entry Point
 */

import { captureUtmParams } from '../../utils/utm.js';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

function init() {
  captureUtmParams();
  setupScrollGuard();
  setupWidgetTriggers();
}

/**
 * Защита от случайных тапов во время скролла.
 * Если палец сдвинулся >8px по вертикали — это скролл, не тап.
 */
let isScrolling = false;
let touchStartY = 0;

function setupScrollGuard() {
  document.addEventListener('touchstart', (e) => {
    touchStartY = e.touches[0]?.clientY ?? 0;
    isScrolling = false;
  }, { passive: true });

  document.addEventListener('touchmove', (e) => {
    if (Math.abs((e.touches[0]?.clientY ?? touchStartY) - touchStartY) > 8) {
      isScrolling = true;
    }
  }, { passive: true });
}

/** Вешаем обработчики на ВСЕ элементы с data-атрибутами (их по 2 на экран) */
function setupWidgetTriggers() {
  document.querySelectorAll('[data-tour-popup-trigger]').forEach(el => {
    el.addEventListener('click', (e) => {
      if (isScrolling) { e.preventDefault(); return; }
      loadTourPopup();
    });
  });

  document.querySelectorAll('[data-stamp-country]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      if (isScrolling) return;
      const code = (el as HTMLElement).dataset.stampCountry!;
      const label = el.querySelector('.tfm-stamp__label')?.textContent?.trim() || code;
      loadStampTours(code, label);
    });
  });

  document.querySelectorAll('[data-chat-widget-trigger]').forEach(el => {
    el.addEventListener('click', () => loadChatWidget());
  });

  document.querySelectorAll('[data-tour-form-trigger]').forEach(el => {
    el.addEventListener('click', () => loadTourForm());
  });
}

async function loadTourPopup() {
  try {
    const { mountTourPopup } = await import('./tour-popup-mount.js');
    mountTourPopup();
  } catch (error) {
    console.error('Failed to load Tour Popup widget:', error);
  }
}

async function loadChatWidget() {
  try {
    const { mountChatWidget } = await import('./chat-widget-mount.js');
    mountChatWidget();
  } catch (error) {
    console.error('Failed to load Chat Widget:', error);
  }
}

async function loadTourForm() {
  try {
    const { mountTourForm } = await import('./tour-form-mount.js');
    mountTourForm();
  } catch (error) {
    console.error('Failed to load Tour Form:', error);
  }
}

/** Предлог и падеж у стран разные, из подписи марки их не вывести. */
const STAMP_TITLES: Record<string, string> = {
  TR: 'Туры в Турцию',
  LK: 'Туры на Шри-Ланку',
  EG: 'Туры в Египет',
  MV: 'Туры на Мальдивы',
  ID: 'Туры в Индонезию',
  VN: 'Туры во Вьетнам',
  TH: 'Туры в Таиланд',
  CN: 'Туры в Китай',
};

async function loadStampTours(countryCode: string, countryName: string) {
  try {
    const { mountTourPopup } = await import('./tour-popup-mount.js');
    mountTourPopup({
      toursUrl: `/api/tours/stamps?country=${encodeURIComponent(countryCode)}`,
      title: STAMP_TITLES[countryCode] ?? `Туры: ${countryName}`,
    });
  } catch (error) {
    console.error('Failed to load stamp tours:', error);
  }
}

